// My Events: adds the garage photo to each car attached to a racer ticket, and a nudge
// when the car has no photo yet. The ticket carries the car's name ("2003 Nissan Skyline
// R34"); the photos live in My Garage, read through the app proxy at /apps/garage.
(function () {
  var root = document.getElementById('my-events');
  if (!root) return;

  var cars = Array.prototype.slice.call(root.querySelectorAll('[data-event-car]'));
  if (cars.length === 0) return;

  var api = root.getAttribute('data-garage-api') || '/apps/garage';

  function normalise(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function title(vehicle) {
    return [vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(' ');
  }

  // The ticket names the car the way the picker wrote it at the time; match loosely on
  // year + make + model (or the nickname) so a later edit in the garage still lines up.
  function findVehicle(vehicles, name) {
    var wanted = normalise(name);
    if (!wanted) return null;
    var exact = vehicles.filter(function (vehicle) {
      return normalise(title(vehicle)) === wanted || normalise(vehicle.nickname) === wanted;
    });
    if (exact.length) return exact[0];
    var loose = vehicles.filter(function (vehicle) {
      var make = normalise(vehicle.make);
      var model = normalise(vehicle.model);
      return make && model && wanted.indexOf(make) !== -1 && wanted.indexOf(model) !== -1;
    });
    return loose[0] || null;
  }

  function cover(vehicle) {
    if (!vehicle) return null;
    var photos = (vehicle.photos || []).filter(function (photo) {
      return photo && photo.url;
    });
    return photos[0] || null;
  }

  fetch(api + '/vehicles', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(function (response) {
      if (!response.ok) throw new Error('garage ' + response.status);
      return response.json();
    })
    .then(function (data) {
      var vehicles = (data && data.vehicles) || [];
      cars.forEach(function (car) {
        var vehicle = findVehicle(vehicles, car.getAttribute('data-vehicle'));
        var photo = cover(vehicle);
        var frame = car.querySelector('[data-car-photo]');
        var nudge = car.querySelector('[data-car-nudge]');
        if (photo) {
          var image = document.createElement('img');
          image.src = photo.url;
          image.alt = car.getAttribute('data-vehicle') || '';
          image.loading = 'lazy';
          if (photo.position) image.style.objectPosition = photo.position;
          frame.appendChild(image);
          frame.hidden = false;
        } else {
          nudge.hidden = false;
        }
      });
    })
    .catch(function () {
      // Garage unavailable: the ticket still shows the car's name, rego and class.
    });
})();
